import PropTypes from "prop-types";
import IconButton from '@mui/material/IconButton';
import MoreVertIcon from '@mui/icons-material/MoreVert'; // Import for the three-dot icon

// @mui material components
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

function ComplexProjectCard({ color, iconName, title, description, onIconClick, onCardClick, isSelected }) {

  
  return (
    <Card sx={{ 
        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)', 
        border: isSelected ? "1px solid #344767" : "none",
        cursor: "pointer",
        '&:hover': {
          boxShadow: "0px 0px 20px rgba(0, 0, 0, 0.2)"
        }
        }} 
        onClick={() => onCardClick(title)}

      >
      <SoftBox p={2}>
        <SoftBox display="flex" alignItems="center" justifyContent="space-between">
          {/* Icon and Title */}
          <SoftBox display="flex" alignItems="center">
            <Icon sx={{ fontSize: { xl: "3rem", md: "3rem", lg: '3rem' }}} >{iconName}</Icon>
            <SoftBox ml={2} lineHeight={0}>
              <SoftTypography variant="h6" textTransform="capitalize" fontWeight="medium">
                {title}
              </SoftTypography>
            </SoftBox>
          </SoftBox>
          {/* More Options Icon */}
          <IconButton 
            onClick={onIconClick}
            sx={{"&:hover": { boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.5)" }}}
          
          >
            <MoreVertIcon />
          </IconButton>
        </SoftBox>
        {/* Description 
        <SoftBox my={2} lineHeight={1}>
          <SoftTypography variant="button" fontWeight="regular" color="text">
            {description}
          </SoftTypography>
        </SoftBox> */}
      </SoftBox>
    </Card>
  );
}

ComplexProjectCard.defaultProps = {
  color: "dark",
};

ComplexProjectCard.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "dark",
    "light",
  ]),
  iconName: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.node,
  onIconClick: PropTypes.func.isRequired, 
  onCardClick: PropTypes.func.isRequired, 
  isSelected: PropTypes.bool

};

export default ComplexProjectCard;
